'use client';

import { Box } from '@mui/material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@/primitives';
import { getHeroSearchTipsContent } from '../quickSearchCopy';

type Props = {
  open: boolean;
  onClose: () => void;
  searchType: string;
};

export default function QuickSearchTipsInfoDialog({
  open,
  onClose,
  searchType,
}: Props) {
  const {
    title,
    intro,
    minLengthNote,
    wildcardIntro,
    wildcardExamples,
    wildcardNote,
  } = getHeroSearchTipsContent(searchType);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Typography variant="bodymedium" sx={{ mb: 2 }}>
          {intro}
        </Typography>
        <Typography
          variant="bodymedium"
          sx={{
            color: 'text.secondary',
            mb: 2,
          }}
        >
          {minLengthNote}
        </Typography>

        <Typography
          component="h3"
          variant="labelmedium"
          sx={{ fontWeight: 600, mb: 1 }}
        >
          Wildcards
        </Typography>
        <Typography variant="bodymedium" sx={{ mb: 1.5 }}>
          {wildcardIntro}
        </Typography>
        <Box
          component="ul"
          sx={{
            m: 0,
            pl: 2.5,
            mb: 2,
            '& li': { mb: 0.75 },
            '& li:last-of-type': { mb: 0 },
          }}
        >
          {wildcardExamples.map(({ pattern, description }) => (
            <Typography key={pattern} component="li" variant="bodymedium">
              <Box
                component="code"
                sx={{
                  fontFamily: 'monospace',
                  fontSize: '0.9em',
                  fontWeight: 600,
                }}
              >
                {pattern}
              </Box>
              {' — '}
              {description}
            </Typography>
          ))}
        </Box>
        <Typography
          variant="bodymedium"
          sx={{
            color: 'text.secondary',
          }}
        >
          {wildcardNote}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
